import { Component, type ErrorInfo, type ReactNode } from 'react';

export class ErrorBoundary extends Component<{ children?: ReactNode }> {
    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error(`${error} with error info ${errorInfo}`);
    }

    render() {
        return this.props.children;
    }
}
